/* global isInvoiceSameAsShipping, addressValidationError*/
import {
  showEditAddressForm,
  setFailedAddressValidationState,
} from './shippingAddress';
import { logError } from '../services/sentryService';
import addressValidation from '../components/addressValidation';
import modal from '../components/modal';
import { fetchRequest, showPageLoader } from '../utils';
import cookies from '../utils/cookies';
import { Action } from '../angular/helpers/address-utils';
import CONSTANTS from '../lib/constants';

const modalContainer = '.modal-container';
const validationFailedCookie = 'failedAddressValidation';
const uniservModalClass = 'js-uniserv-modal';

export const AddressSuggestion = {
  check: (addressType) => {
    if (typeof window.AddressValidation !== 'object') {
      logError('AddressValidation JS is not properly loaded. ');
      return;
    }
    const enteredAddress = addressValidation.getEnteredAddress();
    enteredAddress.country = enteredAddress.countryName;
    enteredAddress.type = addressType;
    window.AddressValidation.renderComponent({
      enteredAddress: enteredAddress,
      customerInfo: enteredAddress,
      consumerName: 'orderPreview',
      config: {
        executionEnvironment: window.environment,
        realm: window.realm,
        locale: window.locale,
      },
      callback: (callbackData) => {
        handleActions(callbackData, addressType);
      },
    });
  },
};

const handleActions = (callbackData, addressType) => {
  const { action, payload = {} } = callbackData;
  switch (action) {
    case Action.SHOW_SUGGESTIONS: {
      showSuggestionModal();
      break;
    }
    case Action.BACK_TO_EDIT: {
      closeSuggestionModal();
      showEditAddressForm();
      break;
    }
    case Action.ACCEPT_AUTOMATICALLY:
    case Action.SAVE_SELECTED_ADDRESS: {
      saveAddress(prepareData(payload), addressType);
      break;
    }
    case Action.SUGGESTIONS_REJECTED:
    case Action.VALIDATION_FAILED:
    case Action.NO_SUGGESTIONS:
    default: {
      handleFailedSuggestion(payload);
      break;
    }
  }
};

const showSuggestionModal = () => {
  modal.openModal($(modalContainer), addEventListeners, removeEventListeners);
  cookies.remove(validationFailedCookie);
};

const addEventListeners = () => {
  document.addEventListener('keydown', handleEscapeKey);
  window.addEventListener('closeModal', handleModalClose);
};

const removeEventListeners = () => {
  document.removeEventListener('keydown', handleEscapeKey);
};

const handleEscapeKey = (event) => {
  if (event.key === 'Escape') {
    closeSuggestionModal();
  }
};

const closeSuggestionModal = () => {
  modal.disposeModal($(`.${uniservModalClass}`));
};

const handleModalClose = (event) => {
  if (event.detail?.contains(uniservModalClass)) {
    window.removeEventListener('closeModal', handleModalClose);
    showEditAddressForm();
  }
};

const prepareData = (payload) => {
  const { address, isEntered, firstSuggestion = {} } = payload;
  let data = {
    ...address.basicInfo,
    ...address.additionalInfo,
    suggestionAccepted: true,
  };

  if (data.suggestionStatus === Action.SHOW_SUGGESTIONS) {
    data.suggestionStatus = 'ACCEPTED';
  }

  if (isEntered) {
    data = { ...firstSuggestion.additionalInfo, ...data };
    data.suggestionStatus = 'NOT_ACCEPTED';
    data.suggestionAccepted = false;
  }
  return data;
};

const saveAddress = async (addressData = {}, addressType = 'delivery') => {
  const enteredAddress = addressValidation.getEnteredAddress();
  const address = { ...enteredAddress, ...addressData };
  address.country = enteredAddress.country;

  const requestData = {
    isUniservAvailable: true,
    address: address,
    uniservAddressValidation: address,
    invoiceSameAsShipping: isInvoiceSameAsShipping,
  };
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-Token': window.csrfToken,
  };
  const url = `/checkout/updateAddressWithUniservData/${addressType}`;
  try {
    const res = await fetchRequest(url, requestData, headers, 'post');
    if (addressData.hasError) {
      return;
    }
    cookies.remove(validationFailedCookie);
    window.location = `${window.location.origin}${res.response.redirectUrl}`;
  } catch (error) {
    logError('Something went wrong while saving the Uniserv data. ', error);
    modal.disposeModal($(modalContainer));
  }
};

const handleFailedSuggestion = (payload) => {
  if (
    payload.address?.additionalInfo?.infoCode ===
    CONSTANTS.ERROR_MESSAGES.UNKNOWN_CITY
  ) {
    addressValidationError.unknownCityError = true;
    return showEditAddressForm();
  }

  const data = { suggestionAccepted: false };
  if (cookies.get(validationFailedCookie)) {
    showPageLoader();
  } else {
    data.hasError = true;
    cookies.set(validationFailedCookie, true);
    setFailedAddressValidationState();
  }
  saveAddress(data);
};
